import { axiosInstance } from "@helpers/axios-instance";
import { DataAwareResponse, TranchRecommendedExercised } from "@/types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

type ReturnType = {
  exercised: TranchRecommendedExercised[];
  recommended: TranchRecommendedExercised[];
};

export function useLTIPTranchDetails(tranchExternalCode: string | undefined) {
  return useQueryWithValidation({
    queryKey: ["sars-tranch-details", String(tranchExternalCode)],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:  `Salesforce/LTIPTranchDetail/${tranchExternalCode}`,
      });
      return data.data as DataAwareResponse<ReturnType>;
    },
    enabled: !!tranchExternalCode,
  });
}
